import { render, staticRenderFns } from "./tab-grid.vue?vue&type=template&id=02a84eb9&scoped=true"
import script from "./tab-grid.vue?vue&type=script&lang=js"
export * from "./tab-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a84eb9",
  null
  
)

export default component.exports